import React, { useState, useEffect, useContext, Fragment } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const TimelineSms = ( { cid, comms } ) => {
    const [ desc, setDesc ] = useState( '' );
    const [ dir, setDir ] = useState( '' );
    const [ msg, setMsg ] = useState( '' );
    
    useEffect( () => {
        if ( comms[cid] ) {
            setDesc( comms[cid].name );
            setMsg( comms[cid].details );
            setDir( comms[cid].direction === 'outbound' ? 'Sent' : 'Received' );
        }
        // console.log( comms[cid] );
    }, [ cid, comms ] );

    return (
        <Container fluid>
            <Row className='pb-2'>
                <Col>
                    <Row>
                        {
                            ( dir === 'Sent' ) ? (
                                <Fragment>
                                    <Col xs={4}></Col>
                                    <Col xs={8} className='tf-sms-sent' dangerouslySetInnerHTML={ { __html: msg } }></Col>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    <Col xs={8} className='tf-sms-received' dangerouslySetInnerHTML={ { __html: msg } }></Col>
                                    <Col xs={4}></Col>
                                </Fragment>
                            )
                        }
                        
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    comms: state.comms.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( TimelineSms );